import {
  useMutation,
  useQueryClient,
  UseMutationOptions,
} from '@tanstack/react-query';
import { Campaign, PatchCampaign } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export interface PatchCampaignParams {
  id: string;
  data: PatchCampaign;
}

export const patchCampaign = async (params: PatchCampaignParams): Promise<Campaign> => {
  return await tinctApi.campaigns.patchCampaign(params.id, params.data);
};

export const usePatchCampaign = (
  options?: Omit<
    UseMutationOptions<Campaign, ApiError, PatchCampaignParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: patchCampaign,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      queryClient.invalidateQueries({ queryKey: ['campaign', args[1].id] });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
